module.exports = "/_next/static/images/contact-us-bg-d0f9e58d99dc8302769287f97320c643.png.webp";